import React from 'react'
import { useTranslation } from 'next-i18next'
import { Link } from 'react-router-dom'
import './LegalPages.scss'

const PrivacyPolicy = () => {
  const { t } = useTranslation()

  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>{t('legal.privacy.title')}</h1>
          <p className="last-updated">{t('legal.privacy.lastUpdated', { date: '15 de enero de 2025' })}</p>

          <section>
            <h2>1. Información General</h2>
            <p>
              PianoMeetups ("nosotros", "nuestro" o "la asociación") se compromete a proteger la privacidad 
              de nuestros usuarios. Esta Política de Privacidad explica cómo recopilamos, utilizamos, 
              divulgamos y protegemos su información cuando utiliza nuestro servicio de venta de entradas.
            </p>
          </section>

          <section>
            <h2>2. Responsable del Tratamiento</h2>
            <p>
              <strong>PianoMeetups</strong><br />
              Dirección: Madrid, España<br />
              Email: info@pianomeetups.com
            </p>
          </section>

          <section>
            <h2>3. Información que Recopilamos</h2>
            <h3>3.1 Información Personal</h3>
            <ul>
              <li><strong>Datos de contacto:</strong> nombre, apellidos, dirección de email, teléfono</li>
              <li><strong>Información de pago:</strong> los datos de tarjeta de crédito/débito son almacenados de forma segura por nuestro proveedor de pagos (CaixaBank/Redsys))</li>
              <li><strong>Información del evento:</strong> preferencias de asientos, necesidades especiales</li>
            </ul>

            <h3>3.2 Información Técnica</h3>
            <ul>
              <li>Dirección IP</li>
              <li>Tipo de navegador y versión</li>
              <li>Configuración de zona horaria</li>
              <li>Ubicación geográfica aproximada</li>
              <li>Información sobre el dispositivo utilizado</li>
            </ul>

            <h3>3.3 Información de Uso</h3>
            <ul>
              <li>Páginas visitadas en nuestro sitio web</li>
              <li>Tiempo de permanencia en cada página</li>
              <li>Enlaces en los que hace clic</li>
              <li>Historial de compras y transacciones</li>
            </ul>
          </section>

          <section>
            <h2>4. Cómo Utilizamos su Información</h2>
            <h3>4.1 Finalidades del Tratamiento</h3>
            <ul>
              <li><strong>Procesamiento de pedidos:</strong> para procesar sus compras de entradas</li>
              <li><strong>Comunicación:</strong> para enviarle confirmaciones, actualizaciones y información del evento</li>
              <li><strong>Atención al cliente:</strong> para responder a sus consultas y proporcionar soporte</li>
              <li><strong>Mejora del servicio:</strong> para analizar el uso del sitio web y mejorar nuestros servicios</li>
              <li><strong>Marketing:</strong> para enviarle información sobre eventos futuros (solo con su consentimiento)</li>
              <li><strong>Cumplimiento legal:</strong> para cumplir con obligaciones legales y fiscales</li>
            </ul>

            <h3>4.2 Base Legal</h3>
            <p>Procesamos su información personal basándonos en:</p>
            <ul>
              <li><strong>Ejecución del contrato:</strong> para procesar sus compras de entradas</li>
              <li><strong>Interés legítimo:</strong> para mejorar nuestros servicios y prevenir fraudes</li>
              <li><strong>Consentimiento:</strong> para comunicaciones de marketing</li>
              <li><strong>Obligación legal:</strong> para cumplir con requisitos fiscales y contables</li>
            </ul>
          </section>

          <section>
            <h2>5. Compartir Información</h2>
            <p>No vendemos, alquilamos ni compartimos su información personal con terceros, excepto en los siguientes casos:</p>
            <ul>
              <li><strong>Proveedores de servicios:</strong> procesadores de pagos, servicios de email, hosting</li>
              <li><strong>Cumplimiento legal:</strong> cuando sea requerido por ley o autoridades competentes</li>
              <li><strong>Protección de derechos:</strong> para proteger nuestros derechos, propiedad o seguridad</li>
              <li><strong>Transferencia de negocio:</strong> en caso de fusión, adquisición o venta de activos</li>
            </ul>
          </section>

          <section>
            <h2>6. Transferencias Internacionales</h2>
            <p>
              Sus datos pueden ser transferidos y procesados en países fuera del Espacio Económico Europeo. 
              En tales casos, garantizamos que se implementen las salvaguardas adecuadas para proteger 
              su información personal de acuerdo con el RGPD.
            </p>
          </section>

          <section>
            <h2>7. Retención de Datos</h2>
            <p>Conservamos su información personal durante los siguientes períodos:</p>
            <ul>
              <li><strong>Datos de transacciones:</strong> 7 años (requisito fiscal)</li>
              <li><strong>Datos de marketing:</strong> hasta que retire su consentimiento</li>
              <li><strong>Datos técnicos:</strong> 2 años desde la última actividad</li>
              <li><strong>Datos de atención al cliente:</strong> 3 años desde la última interacción</li>
            </ul>
          </section>

          <section>
            <h2>8. Seguridad de los Datos</h2>
            <p>
              Implementamos medidas técnicas y organizativas apropiadas para proteger su información personal:
            </p>
            <ul>
              <li>Cifrado SSL/TLS para todas las transmisiones de datos</li>
              <li>Acceso restringido a datos personales solo para personal autorizado</li>
              <li>Auditorías regulares de seguridad</li>
              <li>Copias de seguridad cifradas</li>
              <li>Protocolos de respuesta a incidentes de seguridad</li>
            </ul>
          </section>

          <section>
            <h2>9. Sus Derechos</h2>
            <p>Bajo el RGPD, usted tiene los siguientes derechos:</p>
            <ul>
              <li><strong>Acceso:</strong> solicitar una copia de sus datos personales</li>
              <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos</li>
              <li><strong>Supresión:</strong> solicitar la eliminación de sus datos</li>
              <li><strong>Limitación:</strong> restringir el procesamiento de sus datos</li>
              <li><strong>Portabilidad:</strong> recibir sus datos en un formato estructurado</li>
              <li><strong>Oposición:</strong> oponerse al procesamiento de sus datos</li>
              <li><strong>Retirada del consentimiento:</strong> retirar el consentimiento en cualquier momento</li>
            </ul>
            <p>
              Para ejercer estos derechos, contacte con nosotros en info@pianomeetups.com. 
              Responderemos a su solicitud dentro de un mes.
            </p>
          </section>

          <section>
            <h2>10. Cookies y Tecnologías Similares</h2>
            <h3>10.1 Tipos de Cookies</h3>
            <ul>
              <li><strong>Cookies esenciales:</strong> necesarias para el funcionamiento del sitio web</li>
              <li><strong>Cookies de rendimiento:</strong> para analizar el uso del sitio web</li>
              <li><strong>Cookies de funcionalidad:</strong> para recordar sus preferencias</li>
              <li><strong>Cookies de marketing:</strong> para mostrar contenido relevante (solo con consentimiento)</li>
            </ul>

            <h3>10.2 Gestión de Cookies</h3>
            <p>
              Puede gestionar sus preferencias de cookies a través de la configuración de su navegador. 
              Tenga en cuenta que deshabilitar ciertas cookies puede afectar la funcionalidad del sitio web.
            </p>
          </section>

          <section>
            <h2>11. Menores de Edad</h2>
            <p>
              Nuestro servicio no está dirigido a menores de 16 años. No recopilamos conscientemente 
              información personal de menores de 16 años. Si descubrimos que hemos recopilado información 
              de un menor, la eliminaremos inmediatamente.
            </p>
          </section>

          <section>
            <h2>12. Cambios en esta Política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad ocasionalmente. Le notificaremos cualquier 
              cambio significativo por email o mediante un aviso prominente en nuestro sitio web. 
              La fecha de la última actualización se indica al principio de esta política.
            </p>
          </section>

          <section>
            <h2>13. Contacto y Reclamaciones</h2>
            <p>
              Para cualquier consulta sobre esta Política de Privacidad o el tratamiento de sus datos:
            </p>
            <ul>
              <li>Email: info@pianomeetups.com</li>
              <li>Dirección: Madrid, España</li>
            </ul>
            <p>
              También tiene derecho a presentar una reclamación ante la Agencia Española de Protección 
              de Datos (AEPD) si considera que el tratamiento de sus datos no cumple con la normativa.
            </p>
          </section>

          <div style={{ textAlign: 'center', marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #dee2e6' }}>
            <Link to="/" className="btn btn-primary">
              {t('legal.privacy.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy